import React from 'react';
import { motion } from 'framer-motion';
import type { ChoiceOption } from '../../types/pulse';
interface SelectCueProps {
  options: ChoiceOption[];
  selected: string | null;
  onSelect: (id: string) => void;
  freeText: string;
  onFreeText: (text: string) => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function SelectCue({
  options,
  selected,
  onSelect,
  freeText,
  onFreeText
}: SelectCueProps) {
  const freeOpen = options.find(o => o.id === selected)?.free === true;
  return <div className="flex flex-col gap-2" data-id="element-302" data-mp="uos4bnb2i8sm">
      {options.map(opt => {
      const isMine = selected === opt.id;
      return <button key={opt.id} type="button" onClick={() => onSelect(opt.id)} aria-pressed={isMine} className={`rounded-xl border px-4 py-3.5 text-left transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue ${isMine ? 'border-blue bg-blue/[0.08]' : 'border-line bg-mist hover:border-blue'}`} data-id="element-303" data-mp="znlg9baphrqo">
            <span className="flex items-start gap-3" data-id="element-304" data-mp="1hm9m9tlofpm5">
              <span className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ${isMine ? 'border-blue bg-blue' : 'border-line bg-paper'}`} aria-hidden="true" data-id="element-305" data-mp="1cqkfb57bv6ft">
                {isMine && <span className="h-1.5 w-1.5 rounded-full bg-paper" data-id="element-306" data-mp="yrcey8zfhsa1" />}
              </span>
              <span className="min-w-0 flex-1" data-id="element-307" data-mp="ty9mk46e0ovf">
                <span className="block text-[13px] font-semibold leading-snug text-navy" data-id="element-308" data-mp="ozycptg3eed7">
                  {opt.label}
                </span>
                <span className="mt-1 block text-[11.5px] leading-snug text-mut" data-id="element-309" data-mp="k26i2ro2ce5b">{opt.blurb}</span>
              </span>
            </span>
          </button>;
    })}

      {freeOpen && <motion.div initial={{
      opacity: 0,
      y: 6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.2,
      ease: EASE
    }} data-id="element-310" data-mp="b18fmdt9weou">
          <label className="block" data-id="element-311" data-mp="5dwsbcej546v">
            <span className="sr-only" data-id="element-312" data-mp="5ey3dgvjpqol">Describe the opportunity you see</span>
            <textarea value={freeText} onChange={e => onFreeText(e.target.value)} rows={3} maxLength={220} placeholder="In your own words…" className="w-full resize-none rounded-xl border border-line bg-paper px-4 py-3 text-[13px] leading-snug text-navy placeholder:text-mut focus:border-blue focus:outline-none focus-visible:ring-2 focus-visible:ring-blue" data-id="element-313" data-mp="3nkktwsadf97s" />
          </label>
        </motion.div>}
    </div>;
}